import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { State } from "country-state-city";
import axios from "axios";

export default function FilterModal({
  show,
  onHide,
  applyFilters,
  removeFilters,
  clientFilter,
  setClientFilter,
  apidata,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {" "}
          <Form.Group controlId="clientFilter">
            <Form.Label>Client</Form.Label>
            <Form.Control
              as="select"
              value={clientFilter}
              onChange={(e) => setClientFilter(e.target.value)}
            >
              <option value="">All Clients</option>

              {apidata &&
                apidata
                  .map((item) => item.id_client?.name)
                  .filter((name, index, self) => self.indexOf(name) === index)
                  .filter(Boolean)
                  .map((clientName, index) => (
                    <option key={index} value={clientName}>
                      {clientName}
                    </option>
                  ))}
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="fromDate">
            <Form.Label>From Date</Form.Label>
            <Form.Control
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="toDate" className="mt-2">
            <Form.Label>To Date</Form.Label>
            <Form.Control
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={removeFilters}>
          Remove Filters
        </Button>
        <Button variant="primary" onClick={applyFilters}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
